export default "__VITE_ASSET__Cq0b0O5H__"